import React from "react";
import { Radio } from "antd";
import Scope from "../DesignSystem/Scope/Scope";
import "./Scopes.css";

const Scopes = ({ data, onChange, active }) => {
  return (
    <div className="scopes-wrapper">
      <Radio.Group 
        className="scopes-custom-radio-group" 
        value={active} 
        onChange={onChange} 
        buttonStyle="solid"
      >
        {data.map(({ id, title, subtitle, percent }) => (
          <Radio.Button 
            key={id} 
            value={title} 
            className="scopes-custom-radio-button"
            aria-label={`Select ${title}`}
          >
            <Scope 
              id={id} 
              title={title} 
              subtitle={subtitle} 
              percent={percent} 
              isActive={active === title}
            />
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
};

export default Scopes;